module.exports = "pegasus_template/assets/blocks/capture-9-basic.png";